import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";

export default function KzImageUploaderDropzone({ t, lang }) {
  const [pictures, setPictures] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    // Añadimos nuevas imágenes al estado
    setPictures((prev) => [
      ...prev,
      ...acceptedFiles.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) })
      ),
    ]);
  }, []);

  const maxFiles = 6;
  const maxSize = 10485760; // 10MB
  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif'];

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: allowedExtensions.map(ext => `image/${ext.replace('.', '')}`).join(','),
    maxSize,
    multiple: true,
  });

  return (
    <div>
      <div
        {...getRootProps()}
        style={{
          border: "2px dashed #838B99",
          height: "200px",
          width: "210px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#FFFFFF",
          cursor: "pointer",
        }}
      >
        <input {...getInputProps()} />
        <p>{t.image_upload_title[lang]}</p>
      </div>

      <p style={{ whiteSpace: "pre-wrap" }}>
        {`${t.image_size[lang]}\n${t.image_quantity[lang]}\n${t.image_types[lang]}`}
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", marginTop: "10px" }}>
        {pictures.slice(0, maxFiles).map((file, index) => (
          <div
            key={index}
            style={{
              width: "80px",
              height: "80px",
              marginRight: "10px",
              marginBottom: "10px",
              border: "1px solid #ccc",
              position: "relative",
            }}
          >
            <img
              src={file.preview}
              alt="preview"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
